import styled,{css} from 'styled-components'

export const Container = styled.div`
    margin: 0 0.5rem 0.5rem 0.5rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;

    @media (max-width: 1500px){
        grid-template-columns: 1fr;
    }

    @media (max-width: 800px){
       grid-template-columns: 1fr;
    }

    /* @media (max-width: 1500px){
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);
    }

    @media (max-width: 620px){
       grid-template-columns: 1fr;
       grid-template-rows: repeat(4, 1fr);
    } */
`

export const ContainerFinancialSummary = styled.div`
    display: grid;
    grid-template-columns: repeat(2,1fr);
    gap: 0.5rem;

    @media (max-width: 800px){
       grid-template-columns: 1fr;
       grid-template-rows: repeat(2, 1fr);
    }
`;

export const ContainerTotalSummary = styled.div`
    display: grid;
    grid-template-columns: repeat(3,1fr);
    gap: 0.5rem;

    @media (max-width: 800px){
       grid-template-columns: 1fr;
       grid-template-rows: repeat(2, 1fr);
    }
`;

export const CardFinancialSummary = styled.div`
    padding: 1rem;
    border-radius: 0.25rem;
    
    .container-result{
        cursor: pointer;
    }

    &.green{
        background: #2e9699;
        color: #FFF;
    }

    &.red{
        background: #e05f59;
        color: #FFF;
    }

    &.gray{
        background: var(--colorBackgroundCardsDashboard);
        header{
            color: var(--colorFontsCardsDashboard);
        }
        color: var(--colorFontsCardsDashboard);
    }

    .salesAndTicket{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 1rem;
        line-height: 3rem;
        font-weight: 500;
        font-size: 2rem;

        .message{
            font-size: 1.5rem;
        }
    }

    .svgTicket{
        display: flex;
        align-items: center;

        svg{
            font-size: 1rem;
            margin-right: 0.2rem;
        }
    }

    .aviso{
        font-size: 1.3rem;
        font-weight: bold;
    }

    header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 1rem;

        svg{
            font-size: 2rem;
        }
    }



    strong{
        display: block;
        margin-top: 1rem;
        font-weight: 500;
        line-height: 3rem;
        font-size: 2rem;
    }



    @media (max-width: 1062px){
        header{
            font-size: 0.8rem;

            svg{
                font-size: 1.5rem;
            }

        }

        strong{
            font-size: 1.5rem;
        }
    }

`;

export const GroupSummary = styled.div`
    padding: 1rem;
    border-radius: 0.25rem;

    background: var(--colorBackgroundCardsDashboard);
    color: var(--colorFontsCardsDashboard);
    
    header{
        color: var(--colorFontsCardsDashboard);
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 1rem;

        svg{
            font-size: 2rem;
        }
    }
    
    .quant{
        font-size: 1.3rem;
        font-weight: 500;
    }

    .select{
        border: 0;
        background: transparent;
        width: 100%;
    }
`;